/* loaded by smart-asset */
export default require("./question-circle-solid~pxRPEnon.svg")